module.exports = __webpack_public_path__ + "img/eye-intelligence.a5ee53f6.png";